/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The types for drag and drop dashboard component
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import { ReactElement } from 'react';

import { EWidgetNames, WidgetColumnType } from '../components/Widgets/widgetTypes';

export interface IDraggableWidget {
    column: WidgetColumnType;
    id: string;
    order: number;
    render: () => ReactElement;
}

export type IDraggableWidgetArray = {[K in EWidgetNames]?: IDraggableWidget}
export enum EDraggableID {
    FIRST_ITEMS = 'firstItems',
    SECOND_ITEMS = 'secondItems',
    THIRD_ITEMS = 'thirdItems',
}

